import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { LogService } from './logging/log.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone, private logger: LogService) {}

  handleError(error: any): void {
    if (error instanceof Error) {
      this.zone.run(() => {
        this.logger.error(error.message, error);
      });
    }
  }
}
